import Head from "next/head";
import { SiteHtmlPageTitle, ShortSiteHtmlPageTitle } from "@content/en/HtmlTitle";

type HtmlPageTitleProps = {
  title: string;
};

const HtmlPageTitle = ({ title }: HtmlPageTitleProps) => {
  
  // For SEO purposes, we need to optimize the length of the title.
  // Ideally we want to keep it at about 45 characters, but no more than 60.
  // By performing multiple swaps, we can accommodate longer titles that are 
  // used on specific high-value pages.

  let finalTitle = title;

  // if it's over 60, swap long site title for the short one
  if (finalTitle.length > 60) {
    finalTitle = finalTitle.replace(SiteHtmlPageTitle, ShortSiteHtmlPageTitle);
  }

  // if it's still over 60 after swapping, remove the short site title entirely
  if (finalTitle.length > 60) {
    const removeChunk = ` - ${ShortSiteHtmlPageTitle}`;
    finalTitle = finalTitle.replace(removeChunk, "");
  }

  return (
    <Head>
      <title>{finalTitle}</title>
    </Head>
  );
};

export { HtmlPageTitle };